import { getHeaders, TType, userStore, withRetry } from "@root/common"

export interface GetOrdersRes {
  futures: string[]
  spot: string[]
  margin: string[]
}

export async function getBingxSpotOrderCoins() {
  const outerBaseUrl = await userStore.getOuterBaseUrl()
  const response = await withRetry(async () => await fetch(`${outerBaseUrl}/orders/spot/bingx`, {
      headers: await getHeaders(),
      method: "GET",
  }))
  const json = await response.json()

  if (!response.ok) {
    throw new Error(json.error)
  }

  return json
}


export async function getOrders(): Promise<GetOrdersRes> {
    const outerBaseUrl = await userStore.getOuterBaseUrl()
    const response = await withRetry(async () => await fetch(`${outerBaseUrl}/orders`, {
        headers: await getHeaders(),
        method: "GET",
    }))
    const json = await response.json()

    if (!response.ok) {
      throw new Error(json.error)
    }

    return json
}

export enum OrdersMode {
  LIMIT = "limit",
  MARKET = "market",
  FAST = "fast"
}

export enum OrdersMargin {
  CROSS = "cross",
  ISOLATED = "isolated"
}

export type SendOrderReq = {
  type: TType
  long: string
  short: string
  coin: string
  amount: number
  is_in_coins: boolean
  liquidation: boolean
  settings: {
    type: OrdersMode
    slippage: number
    leverage: number
    long_price: number
    short_price: number
    margin: OrdersMargin
  }
} & (
  {
    is_exit: true,
    is_full_position: boolean
  }
| {
    is_exit: false
  }
)

export interface OrderLogs {
  errors: {
    type: string
    message: string
  }[],
  success_logs: {
    type: string
    message: string
  }[]
}

export type SendOrderRes = Record<string, OrderLogs>

export async function sendOrder(body: SendOrderReq): Promise<SendOrderRes | undefined> {
  try {
    const outerBaseUrl = await userStore.getOuterBaseUrl()
    const response = await withRetry(async () => await fetch(`${outerBaseUrl}/orders`, {
        headers: await getHeaders(),
        method: "POST",
        body: JSON.stringify(body)
    }))
    const json = await response.json()

    if (!response.ok && json?.error) {
      const result: SendOrderRes = {
        [body.long]: {
          success_logs: [],
          errors: [{
            type: "Ошибка",
            message: json.error
          }]
        },
        [body.short]: {
          success_logs: [],
          errors: [{
            type: "Ошибка",
            message: json.error
          }]
        }
      }
      return result
    }

    return json
  } catch (e) {
    console.error(e)
    return undefined;
  }
}

export interface GetOrdersPositionQuery {
  type: string
  long: string
  short: string
  coin: string
}

export interface PositionResponse {
  amount: number
  long_amount: number
  short_amount: number
}


export async function getOrdersPosition(query: GetOrdersPositionQuery): Promise<PositionResponse> {
    const outerBaseUrl = await userStore.getOuterBaseUrl()
    const searchParams = new URLSearchParams({...query})
    const response = await withRetry(async () => await fetch(`${outerBaseUrl}/orders/position?${searchParams}`, {
        headers: await getHeaders(),
        method: "GET",
    }))
    const json = await response.json()

    if (!response.ok) {
      throw new Error(json.error)
    }

    return json
}
